'use strict'

import { Flex } from '@symbo.ls/atoms'

export const CountIndicator = {
  extend: Flex,
  props: {
    text: '2',
    theme: 'primary',
    widthRange: 'A1',
    boxSizing: 'content-box',
    lineHeight: '1em',
    padding: 'X',
    round: '100%',
    align: 'center center',
    aspectRatio: '1 / 1'
  }
}
